<template class="additionalContact">
    <tbody>
        <tr>
            <th colspan="2">
                <label class="font-weight-bold text-uppercase">Additional Contact {{position + 1}}</label>
                <div
                    class="btn btn-danger btn-sm float-right"
                    @click="$emit('deleteItem', position)" >
                    <i class="fas fa-trash-alt"></i>
                </div>
            </th>
        </tr>
        
        <tr>
            <th><label class="required">Full Name</label></th>
            <td>
                <div class="form-group" :class="{error: $v.contact.fullName.$error}">
                    <input type="text" class="form-control" placeholder="Full Name" v-model="contact.fullName" />
                    <p class="help-block" v-if="$v.contact.$error && !$v.contact.fullName.required"><i class="fas fa-exclamation-triangle"></i> Please enter the contact's full name.</p>
                </div>
            </td>
        </tr>
        <tr>
            <th><label class="required">E-mail Address</label></th>
            <td>
                <div class="form-group" :class="{error: $v.contact.email.$error}">
                    <input type="text" class="form-control" placeholder="E-mail Address" v-model="contact.email" />
                    <p class="help-block" v-if="$v.contact.$error && !$v.contact.email.required"><i class="fas fa-exclamation-triangle"></i> Please enter the contact's email address.</p>
                    <p class="help-block" v-if="$v.contact.$error && !$v.contact.email.email"><i class="fas fa-exclamation-triangle"></i> Please enter a valid email address.</p>
                </div>
            </td>
        </tr>
        <tr>
            <th><label></label>Mobile Number</th>
            <td>
                <div class="form-group" :class="{error: $v.contact.mobile.$error}">
                    <input type="text" class="form-control" placeholder="Mobile Number" v-model="contact.mobile" />
                    <p class="help-block" v-if="$v.contact.$error && !$v.contact.mobile.isValidPhone"><i class="fas fa-exclamation-triangle"></i> Invalid Phone Number - It must be numeric, at least 3 digits and at most 17 digits. Can start with +.</p>
                </div>
            </td>
        </tr>
        <tr>
            <th><label class="required">Type</label></th>
            <td>
                <div class="form-group" :class="{error: $v.contact.type.$error}">
                    <select class="form-control" v-model="contact.type" >
                        <option value="">-- Select Contact Type --</option>
                        <option value="BILLING">Billing</option>
                        <option value="TECHNICAL">Technical</option>
                        <option value="BOTH">Both</option>
                    </select>
                    <p class="help-block" v-if="$v.contact.$error && !$v.contact.type.required"><i class="fas fa-exclamation-triangle"></i> Please select the contact's type.</p>
                </div>
            </td>
        </tr>
    </tbody>
</template>

<script>

import { required, requiredIf, minLength, between, email, helpers } from 'vuelidate/lib/validators'
const phoneRegex = /^[+]{0,1}[0-9]{3,17}$/; //Only + and digits allowed. Minimum 3 digits and maximum 17.

export default {
    name: "AdditionalContact",
    props: {
        contact: {
            type: Object,
            required: true
        },
        position: {
            type: Number,
            required: true,
        }, 
        validate: {
            type: Number,
        },
    },

    data() {
        return {
          
        };
    },
    validations:{
        contact: {
            fullName: {
                required
            },
            email: {
                required,
                email
            },
            mobile: {
                isValidPhone: function(mobile){
                    return !helpers.req(mobile) || phoneRegex.test(mobile); 
                }
            },
            type: {
                required
            }
        },
    },
    watch: {

        /**
         * Controls the user type
         * @return void
         */
        'contact.type': function()
        {
            this.contact.sendBilling   = (this.contact.type === 'BILLING' || this.contact.type === 'BOTH');
            this.contact.sendTechnical = (this.contact.type === 'TECHNICAL' || this.contact.type === 'BOTH');
        },

        validate: function(){
            this.$v.contact.$touch();
        }

    }
}
</script>
